// @flow
import { addCellPrefixModalActions } from './addCellPrefixModalActionCreator';

const initialState = {
  showAddCellPrefixModal: false,
  cellList: {
    isLoading: false,
    isLoaded: true,
    data: { status: null, val: [] }
  }
};

const addCellPrefixModalReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case addCellPrefixModalActions.GET_AVAILABLE_CELLS_WITHOUT_SAVE:
      return Object.assign({}, state, { cellList: action.payload });
    default:
      return state;
  }
};

export default addCellPrefixModalReducer;
